var map = {
	"./1g.svg": "5cb1",
	"./2g.svg": "e19b",
	"./3g.svg": "35ee",
	"./4g.svg": "c16a",
	"./5g.svg": "eb99",
	"./6g.svg": "189f",
	"./7g.svg": "ac2f",
	"./ThaiFlag.svg": "64bf",
	"./UkFlag.svg": "bc9f",
	"./maintenance_bg.svg": "7968"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "add7";